import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=62cc4bfa&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc4bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cc4bfa')) {
      api.createRecord('62cc4bfa', component.options)
    } else {
      api.reload('62cc4bfa', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=62cc4bfa&scoped=true&", function () {
      api.rerender('62cc4bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OzeNaaZ0ShDS/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports